module.exports = __webpack_public_path__ + "img/logo-egresados.10cb8114.png";